import { render, staticRenderFns } from "./performanceorderList.vue?vue&type=template&id=6d9796d6"
import script from "./performanceorderList.vue?vue&type=script&lang=js"
export * from "./performanceorderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports